module.exports = __webpack_public_path__ + "img/Flask.74a5d964.png";